
import { PAGE_TYPE, QUERY_CONTACT_US } from "./-contact-us.query";
import { seoMixin, pageMixin } from "~/mixins";
import { getContactPageSchemaScript } from "~/utils/organization-schema";

const UID = "contact-us";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({ app }) {
    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: QUERY_CONTACT_US,
      variables: { uid: UID },
    });

    return {
      title: data.title,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
      serviceData: data,
      pageType: PAGE_TYPE,
      uid: UID,
    };
  },

  computed: {
    additionalScripts() {
      return getContactPageSchemaScript(
        this.$config.appEndPoint,
        this.serviceData,
        this.$store.state.prismicOrganizationSettings
      );
    },
  },
};
